module.exports = __webpack_public_path__ + "static/assets/bc296f38c5bcf40be1451e11ddaa07c6.gif";